import {Component, inject, Input, OnInit} from '@angular/core';
import {ViewField} from "../../core/definitions/object-view";
import { FeatureFlagsService } from '../../core/feature-flags.service';

@Component({
    selector: 'app-object-view-show-more',
    templateUrl: './object-view-show-more.component.html',
    styleUrls: ['./object-view-show-more.component.scss'],
    standalone: false
})
export class ObjectViewShowMoreComponent implements OnInit {
  // Injections
  private readonly featureFlags: FeatureFlagsService = inject(FeatureFlagsService);

  @Input() field: ViewField;
  listName: string;

  ngOnInit() {
    if (['children', 'parents', 'relationships'].includes(this.field.field_name)) {
      this.listName = this.field.field_name
    }
  }

  get newListViewRouterLink(): string {
    return location.pathname.replace('overview', this.listName);
  }

  protected readonly newObjectView = this.featureFlags.getFeatureFlags()?.experimental?.useNewObjectPage;
}
